!function () {
	class e extends HTMLElement {
		constructor() {
			super(), this.bindEvents = this.bindEvents.bind(this), this.loadMoreItems = this.loadMoreItems.bind(this)
		}

		connectedCallback() {
			if (this.loadMoreEl = this, this.containerId = this.loadMoreEl.dataset.container, this.itemsGridContainer = document.querySelector(`#${this.containerId}`), this.nextUrl = this.itemsGridContainer.dataset.nextUrl, this.loadMoreBtn = this.loadMoreEl.querySelector(".js-load-more-btn"), this.loadMoreBtn) this.bindEvents(); else {
				let e = new MutationObserver(() => {
					this.loadMoreBtn = this.loadMoreEl.querySelector(".js-load-more-btn"), this.loadMoreBtn && (this.bindEvents(), e.disconnect())
				});
				e.observe(document.documentElement, {childList: !0, subtree: !0})
			}
		}

		bindEvents() {
			this.totalItemsViewed = this.loadMoreEl.querySelector(".js-total-items"), this.nextUrl && this.loadMoreBtn && this.loadMoreBtn.addEventListener("click", () => this.loadMoreItems())
		}

		async loadMoreItems() {
			this.loadMoreBtn.classList.add("button-loading"), !1 == this.nextUrl.includes("article-grid") && (this.nextUrl = this.nextUrl + "&view=ajax");
			let e = document.querySelector("#article-grid");
			e && e.classList.add("u-visibility-hidden"), await fetch(`${this.nextUrl}`).then(e => e.text()).then(t => {
				if (!1 == this.nextUrl.includes("article-grid")) {
					let e = this.nextUrl.replace("&view=ajax", "");
					history.pushState("", "", e)
				}
				let s = new DOMParser().parseFromString(t, "text/html"), i = s.querySelector(`#${this.containerId}`);
				i && (this.itemsGridContainer.innerHTML += i.innerHTML);

				// Observer pour le lazy loading des images, mais ne pas réinitialiser celles déjà chargées
				const lazyImages = document.querySelectorAll(".lozad");
				lazyImages.forEach(img => {
					if (img.dataset.loaded === "true") {
						img.classList.remove("lozad");
					}
				});
				window.lozadObserver.observe();

				let r = s.querySelector(".js-total-items");
				r && (this.totalItemsViewed.innerHTML = r.innerHTML), this.loadMoreBtn.classList.remove("button-loading");
				let n = i?.dataset.nextUrl;
				n ? this.nextUrl = n : this.loadMoreBtn.style.display = "none", e && ([...e.children].sort((e, t) => e.dataset.publishedAt < t.dataset.publishedAt ? 1 : -1).forEach(t => e.appendChild(t)), e.classList.remove("u-visibility-hidden")), document.dispatchEvent(new CustomEvent("listing-load-more:loaded"))
			}).catch(function (e) {
				this.loadMoreBtn.classList.remove("button-loading")
			})
		}
	}

	customElements.define("w3-load-more", e);

	class t extends HTMLElement {
		constructor() {
			super(), this.bindEvents = this.bindEvents.bind(this), this.onScrollHandler = this.onScroll.bind(this)
		}

		connectedCallback() {
			this.CollectionsTopbar = {}, this.collectionsTopbarEl = this, this.mainCollectionHero = document.querySelector("#main-collection-filters"), this.productGridContainer = document.querySelector("#ProductGridContainer"), this.scrollbarAvancement = this.collectionsTopbarEl.querySelector(".js-progress-bar-avancement"), this.currentScrollTop = 0, this.bindEvents()
		}

		bindEvents() {
			this.collectionsTopbarEl && (window.addEventListener("scroll", () => {
				this.onScrollHandler(), this.scaleProgressBar()
			}, !1), document.addEventListener("listing-load-more:loaded", () => {
				this.scaleProgressBar()
			}), window.addEventListener("resize", () => {
				this.scaleProgressBar()
			}, !1))
		}

		scaleProgressBar() {
			let e = window.pageYOffset || document.documentElement.scrollTop,
				t = this.productGridContainer.getBoundingClientRect().height + this.mainCollectionHero.getBoundingClientRect().height,
				s = window.innerHeight;
			this.scrollbarAvancement.style.transform = `scaleX(${e / (t - s)})`
		}

		onScroll() {
			let e = window.pageYOffset || document.documentElement.scrollTop;
			if (e < this.currentScrollTop) {
				this.collectionsTopbarEl.classList.remove("collections-topbar--visible"), this.currentScrollTop = e;
				return
			}
			let t = this.productGridContainer.getBoundingClientRect(), s = t.top > 0,
				i = t.bottom <= window.innerHeight;
			s ? this.collectionsTopbarEl.classList.remove("collections-topbar--visible") : s || i ? i && this.collectionsTopbarEl.classList.remove("collections-topbar--visible") : this.collectionsTopbarEl.classList.add("collections-topbar--visible"), this.currentScrollTop = e
		}
	}

	customElements.define("w3-collections-topbar", t);

	class s extends HTMLElement {
		constructor() {
			super(), this.bindEvents = this.bindEvents.bind(this), this.openDrawer = this.openDrawer.bind(this), this.closeDrawer = this.closeDrawer.bind(this), this.onClickOutside = this.onClickOutside.bind(this), this.createCustomEvents = this.createCustomEvents.bind(this), this.onEchap = this.onEchap.bind(this)
		}

		connectedCallback() {
			this.Drawer = this, this.drawerSidebarEl = this.getElement(".js-drawer-sidebar"), this.drawerOverlayEl = this.getElement(".js-drawer-overlay"), this.hasCustomEvents = this.Drawer.hasAttribute("has-custom-event") || !1, this.disableClickOutside = this.Drawer.hasAttribute("disable-click-outside") || !1, this.drawerName = this.getAttribute("drawer-name") || "drawer", this.isDrawerMobile = this.Drawer.hasAttribute("mobile-only") || !1, this.isDrawerOpen = !1, this.isAnyDrawerVisible = !1, this.mobileBreakpoint = 1024, this.bodyTopPosition = 0, this.speed = parseInt(this.Drawer.getAttribute("speed-transition")) || 600, this.isMobile = this.checkIfMobile(), (!this.isDrawerMobile || this.isMobile) && this.bindEvents()
		}

		openDrawer() {
			this.isDrawerOpen || (this.hasCustomEvents && this.Drawer.dispatchEvent(this.customEventDrawerOpen), this.Drawer.getAttribute("closer") ? this.drawerBtnsClose = document.querySelectorAll(this.Drawer.getAttribute("closer")) : this.drawerBtnsClose = this.Drawer.querySelectorAll(".js-drawer-close"), void 0 !== this.drawerBtnsClose && this.drawerBtnsClose.length > 0 && this.drawerBtnsClose.forEach(e => {
				e.addEventListener("click", this.closeDrawer)
			}), document.body.classList.add("drawer-visible", `${this.drawerName}-visible`), this.Drawer.classList.add("drawer--visible"), setTimeout(() => {
				this.isMobile && this.lockScroll(), this.isDrawerOpen = !0, document.addEventListener("keyup", this.onEchap), document.addEventListener("click", this.onClickOutside), window.lozadObserver.observe()
			}, this.speed))
		}

		closeDrawer() {
			this.isDrawerOpen && (this.hasCustomEvents && this.Drawer.dispatchEvent(this.customEventDrawerClose), this.Drawer.classList.add("drawer-transition-out"), document.removeEventListener("keyup", this.onEchap), document.removeEventListener("click", this.onClickOutside), this.isMobile && this.unLockScroll(), setTimeout(() => {
				this.isDrawerOpen = !1, this.Drawer.classList.remove("drawer--visible", "drawer-transition-out"), document.body.classList.remove(`${this.drawerName}-visible`), this.isAnyDrawerVisible || document.body.classList.remove("drawer-visible")
			}, this.speed))
		}

		lockScroll() {
			this.bodyTopPosition = document.documentElement.scrollTop, document.body.style.top = `-${this.bodyTopPosition}px`, document.documentElement.classList.add("lock-scroll")
		}

		unLockScroll() {
			document.documentElement.classList.remove("lock-scroll"), window.scrollTo({
				left: 0,
				top: this.bodyTopPosition,
				behavior: "instant"
			}), document.body.style.top = "unset"
		}

		onEchap(e) {
			27 === e.keyCode && this.closeDrawer()
		}

		onClickOutside(e) {
			this.drawerSidebarEl.contains(e.target) || this.disableClickOutside || this.closeDrawer()
		}

		createCustomEvents() {
			this.customEventDrawerOpen = new CustomEvent("drawer--open", {
				bubbles: !0,
				cancelable: !0,
				composed: !1
			}), this.customEventDrawerClose = new CustomEvent("drawer--close", {
				bubbles: !0,
				cancelable: !0,
				composed: !1
			})
		}

		getElement(e, t = !1) {
			return t ? this.Drawer.querySelectorAll(e) || [] : this.Drawer.querySelector(e) || null
		}

		checkIfMobile() {
			return window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches
		}

		checkIfAnyDrawerVisible() {
			document.body.classList.contains("drawer-visible") && (this.isAnyDrawerVisible = !0)
		}

		bindEvents() {
			if (this.Drawer.getAttribute("opener") && (this.drawerBtnsOpen = document.querySelectorAll(this.Drawer.getAttribute("opener"))), this.drawerBtnsOpen) for (let e of this.drawerBtnsOpen) e.addEventListener("click", this.openDrawer);
			this.drawerOverlayEl && this.drawerOverlayEl.addEventListener("click", () => {
				this.closeDrawer()
			}), this.hasCustomEvents && this.createCustomEvents()
		}

		disconnectedCallback() {
			if (this.drawerBtnsOpen) for (let e of this.drawerBtnsOpen) e.removeEventListener("click", this.openDrawer);
			void 0 !== this.drawerBtnsClose && this.drawerBtnsClose.length > 1 && this.drawerBtnsClose.forEach(e => {
				e.removeEventListener("click", this.closeDrawer)
			})
		}
	}

	void 0 === customElements.get("w3-drawer") && customElements.define("w3-drawer", s), customElements.define("w3-drawer-filters", class extends s {
		constructor() {
			super(), this.filterClearButton = this.querySelector(".js-filter-clear")
		}

		connectedCallback() {
			super.connectedCallback(), window.addEventListener("search:updated", () => {
				super.bindEvents();
				let e = new URLSearchParams(window.location.search), t = e.get("q"), s = e.get("type");
				this.filterClearButton.href = window.location.origin + window.location.pathname + `?q=${t}&type=${s}`
			})
		}
	});

	class i extends HTMLElement {
		constructor() {
			super(), this.onActiveFilterClick = this.onActiveFilterClick.bind(this), this.disableSortBy = this.disableSortBy.bind(this), this.setListeners = this.setListeners.bind(this), this.toggleActiveFacets = this.toggleActiveFacets.bind(this), this.renderPage = this.renderPage.bind(this), this.renderSectionFromFetch = this.renderSectionFromFetch.bind(this), this.renderSectionFromCache = this.renderSectionFromCache.bind(this), this.renderFilters = this.renderFilters.bind(this), this.renderActiveFacets = this.renderActiveFacets.bind(this), this.renderCurrentFacet = this.renderCurrentFacet.bind(this), this.updateURLHash = this.updateURLHash.bind(this), this.getSections = this.getSections.bind(this), this.renderUpdatedElements = this.renderUpdatedElements.bind(this), this.filterData = [], this.searchParamsInitial = window.location.search.slice(1), this.searchParamsPrev = window.location.search.slice(1), this.setListeners(), this.debouncedOnSubmit = debounce(e => {
				this.onSubmitHandler(e)
			}, 500), this.querySelector("form")?.addEventListener("input", this.debouncedOnSubmit.bind(this)), this.mobileBreakpoint = 1024, this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches, this.disableSortBy(), this.checkIfActiveFilters()
		}

		disableSortBy() {
			this.isMobile ? document.querySelector(".js-facets-sort-by-desktop").disabled = !0 : document.querySelectorAll(".js-facets-sort-by-mobile").forEach(e => {
				e.disabled = !0
			})
		}

		setListeners() {
			window.addEventListener("popstate", e => {
				let t = e.state ? e.state.searchParams : this.searchParamsInitial;
				t !== this.searchParamsPrev && this.renderPage(t, null, !1)
			})
		}

		checkIfActiveFilters() {
			let e = document.querySelectorAll(".js-active-facets facet-remove"),
				t = document.querySelectorAll(".js-filter-count"), s = e.length;
			if (s > 0) for (let e of t) e.textContent = `${s}`, e.classList.remove("u-none"); else for (let e of t) e.classList.add("u-none"), e.textContent = ""
		}

		toggleActiveFacets(e = !0) {
			document.querySelectorAll(".js-facet-clear").forEach(t => {
				t.classList.toggle("disabled", e)
			})
		}

		renderPage(e, t, s = !0) {
			this.searchParamsPrev = e;
			let i = this.getSections();
			document.body.classList.add("is-loading"), i.forEach(s => {
				let i = `${window.location.pathname}?${e}`, r = e => e.url === i;
				this.filterData.some(r) ? this.renderSectionFromCache(r, t) : this.renderSectionFromFetch(i, t)
			}), s && this.updateURLHash(e)
		}

		renderSectionFromFetch(e, t) {
			fetch(e).then(e => e.text()).then(s => {
				this.filterData = [...this.filterData, {
					html: s,
					url: e
				}], this.renderFilters(s, t), this.renderUpdatedElements(s), this.disableSortBy(), this.checkIfActiveFilters(), window.lozadObserver.observe()
			})
		}

		renderSectionFromCache(e, t) {
			let s = this.filterData.find(e).html;
			this.renderFilters(s, t), this.renderUpdatedElements(s), this.disableSortBy(), this.checkIfActiveFilters(), window.lozadObserver.observe()
		}

		renderUpdatedElements(e) {
			let t = new DOMParser().parseFromString(e, "text/html");
			this.getElementsToUpdate().forEach(e => {
				let s = t.querySelector(e), i = document.querySelector(e);
				i && s && !i.isEqualNode(s) && (i.innerHTML = s.innerHTML)
			})
		}

		getElementsToUpdate() {
			return ["#ProductGridContainer", "#ProductCount", "#ProductCountDrawer"]
		}

		renderFilters(e, t) {
			let s = new DOMParser().parseFromString(e, "text/html"),
				i = s.querySelectorAll("#FacetFiltersForm .js-filter"), r = e => {
					let s = t ? t.target.closest(".js-filter") : void 0;
					return !!s && e.dataset.index === s.dataset.index
				}, n = Array.from(i).filter(e => !r(e)), o = Array.from(i).find(r);
			n.forEach(e => {
				document.querySelector(`.js-filter[data-index="${e.dataset.index}"]`).innerHTML = e.innerHTML
			}), this.renderActiveFacets(s), o && this.renderCurrentFacet(o, t.target.closest(".js-filter")), document.body.classList.remove("is-loading")
		}

		renderActiveFacets(e) {
			[".js-active-facets"].forEach(t => {
				let s = e.querySelector(t);
				s && (document.querySelector(t).innerHTML = s.innerHTML)
			}), this.toggleActiveFacets(!1)
		}

		renderCurrentFacet(e, t) {
			let s = t.querySelector(".js-filter-label"), i = e.querySelector(".js-filter-label");
			i && s && (s.innerHTML = i.innerHTML)
		}

		updateURLHash(e) {
			history.pushState({searchParams: e}, "", `${window.location.pathname}${e && "?".concat(e)}`)
		}

		getSections() {
			return [{section: document.getElementById("product-grid").dataset.id}]
		}

		onSubmitHandler(e) {
			e.preventDefault();
			let t = new FormData(e.target.closest("form")), s = new URLSearchParams(t).toString(), i = s;
			if (document.querySelector(".js-search-form")) {
				let e = new FormData(document.querySelector(".js-search-form")), t = new URLSearchParams(e).get("q");
				t && "" != t && (i = `q=${t}&type=product${"" != s ? "&" + s : ""}`)
			}
			this.renderPage(i, e)
		}

		onActiveFilterClick(e) {
			e.preventDefault(), this.toggleActiveFacets();
			let t = -1 == e.currentTarget.href.indexOf("?") ? "" : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
			this.renderPage(t)
		}
	}

	customElements.define("facet-filters-form", i);

	class r extends HTMLElement {
		constructor() {
			super(), this.querySelector("a").addEventListener("click", e => {
				e.preventDefault(), (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(e)
			})
		}
	}

	customElements.define("facet-clear", r)
}();